import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.7064 4.65984C19.5778 2.74077 16.8472 3.51413 15.2068 4.74602C14.5342 5.25112 14.1979 5.50367 14 5.50367C13.8022 5.50367 13.4659 5.25112 12.7933 4.74602L12.7933 4.74602C11.1529 3.51413 8.42231 2.74077 5.29372 4.65984C1.18779 7.17842 0.258715 15.4873 9.72949 22.4972C11.5334 23.8324 12.4353 24.5 14 24.5C15.5648 24.5 16.4667 23.8324 18.2706 22.4972C27.7414 15.4873 26.8123 7.17842 22.7064 4.65984Z",
      stroke: "#B7B7B7",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }